import React, { KeyboardEvent, ChangeEvent, createRef, memo } from 'react';

type SearchFieldProps = {
  id: string;
  placeholder?: string;
  value?: string;
  label?: string;
  showButton: boolean;
  onKeyUp: (e: KeyboardEvent<HTMLInputElement>) => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  onClick: () => void;
};

export const SearchField = memo(
  ({ id, placeholder, value, label, showButton, onChange, onFocus, onKeyUp, onClick }: SearchFieldProps) => {
    const searchFieldRef = createRef<HTMLInputElement>();

    return (
      <>
        <div className="thule-input">
          <label htmlFor={id} className="visually-hidden">
            {label}
          </label>
          <div className="position-relative">
            <i className="leading-icon le-icon-search"></i>
            <input
              type="text"
              placeholder={placeholder}
              className="input px-9 px-9"
              id={id}
              name={id}
              onChange={onChange}
              onFocus={onFocus}
              onKeyUp={onKeyUp}
              value={value}
              enterKeyHint="search"
              autoComplete="off"
              ref={searchFieldRef}
            />
          </div>
        </div>
        {showButton && <button onClick={onClick}>{label}</button>}
      </>
    );
  }
);
